<template>
  <div>
    <el-dialog
      title="自定义指标"
      center
      :visible="visible"
      width="930px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      top="6vh"
    >
      <div class="formData" v-loading="dataLoading">
        <el-form
          :model="indicatorsForm"
          size="small"
          :inline="true"
          :rules="rules"
          ref="indicatorsForm"
        >
          
          <div class="tips">
            <div class="string"></div>新会员首购率</div>
          <el-form-item label="行业均值：" class="long-form" prop="firstBuyMeanValue">
            <el-input
              v-model="indicatorsForm.firstBuyMeanValue"
              placeholder="请输入"
              @change="inputNumber0($event,'firstBuyMeanValue')"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.firstBuyMeanValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <el-form-item label="紧急提升：">小于行业均值</el-form-item>
          <el-form-item label="达标：" prop="firstBuyReachLessValue">
            大于等于行业均值，且小于
            <el-input
              v-model="indicatorsForm.firstBuyReachLessValue"
              placeholder="请输入"
              @change="inputNumber0($event,'firstBuyReachLessValue')"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.firstBuyReachLessValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <el-form-item
            label="优秀："
            style=" margin: 15px 0 15px 10px;"
            prop="firstBuyExcellentMoreValue"
          >
            大于等于
            <el-input
              v-model="indicatorsForm.firstBuyExcellentMoreValue"
              placeholder="请输入"
              @change="inputNumber0($event,'firstBuyExcellentMoreValue')"
              :disabled="true"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.firstBuyExcellentMoreValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <div class="tips"><div class="string"></div>已购会员占比</div>
          <el-form-item label="行业均值：" class="long-form" prop="purchasedMeanValue">
            <el-input
              v-model="indicatorsForm.purchasedMeanValue"
              placeholder="请输入"
              @change="inputNumber0($event,'purchasedMeanValue')"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.purchasedMeanValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <el-form-item label="紧急提升：">小于行业均值</el-form-item>
          <el-form-item label="达标：" prop="purchasedReachLessValue">
            大于等于行业均值，且小于
            <el-input
              v-model="indicatorsForm.purchasedReachLessValue"
              placeholder="请输入"
              @change="inputNumber0($event,'purchasedReachLessValue')"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.purchasedReachLessValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <el-form-item
            label="优秀："
            style=" margin: 15px 0 15px 10px;"
            prop="purchasedExcellentMoreValue"
          >
            大于等于
            <el-input
              v-model="indicatorsForm.purchasedExcellentMoreValue"
              placeholder="请输入"
              @change="inputNumber0($event,'purchasedExcellentMoreValue')"
              :disabled="true"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.purchasedExcellentMoreValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <div class="tips"><div class="string"></div>近90天复购率</div>
          <el-form-item label="行业均值：" class="long-form" prop="repurchase90MeanValue">
            <el-input
              v-model="indicatorsForm.repurchase90MeanValue"
              placeholder="请输入"
              @change="inputNumber0($event,'repurchase90MeanValue')"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.repurchase90MeanValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <el-form-item label="紧急提升：">小于行业均值</el-form-item>
          <el-form-item label="达标：" prop="repurchase90ReachLessValue">
            大于等于行业均值，且小于
            <el-input
              v-model="indicatorsForm.repurchase90ReachLessValue"
              placeholder="请输入"
              @change="inputNumber0($event,'repurchase90ReachLessValue')"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.repurchase90ReachLessValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <el-form-item
            label="优秀："
            style=" margin: 15px 0 15px 10px;"
            prop="repurchase90ExcellentMoreValue"
          >
            大于等于
            <el-input
              v-model="indicatorsForm.repurchase90ExcellentMoreValue"
              placeholder="请输入"
              @change="inputNumber0($event,'repurchase90ExcellentMoreValue')"
              :disabled="true"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.repurchase90ExcellentMoreValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <div class="tips"><div class="string"></div>流失客户占比</div>
          <el-form-item label="行业均值：" class="long-form" prop="lossMeanValue">
            <el-input
              v-model="indicatorsForm.lossMeanValue"
              placeholder="请输入"
              @change="inputNumber0($event,'lossMeanValue')"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.lossMeanValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <el-form-item label="紧急提升：">大于行业均值</el-form-item>
          <el-form-item label="达标：" prop="lossReachMoreValue">
            大于
            <el-input
              v-model="indicatorsForm.lossReachMoreValue"
              placeholder="请输入"
              @change="inputNumber0($event,'lossReachMoreValue')"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.lossReachMoreValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%，且小于等于行业均值</span>
          </el-form-item>
          <el-form-item
            label="优秀："
            style=" margin: 15px 0 15px 10px;"
            prop="lossExcellentLessValue"
          >
            小于等于
            <el-input
              v-model="indicatorsForm.lossExcellentLessValue"
              placeholder="请输入"
              @change="inputNumber0($event,'lossExcellentLessValue')"
              :disabled="true"
              oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
              @input="indicatorsForm.lossExcellentLessValue = getNumberData($event)"
            ></el-input>
            <span class="icon">%</span>
          </el-form-item>
          <el-form-item>
            <div class="oldBtn" @click="oldBtn">一键恢复默认</div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('indicatorsForm')"
          :disabled="isSaveLoading"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { indexCustom, index, saveCustom } from "@/api/industry/strategy.js";

export default {
  name: "viewBuyerDialog",
  props: {},
  data() {
    var firstBuyReachLessValue = (rule, value, callback) => {
      if (Number(value) < Number(this.indicatorsForm.firstBuyMeanValue)) {
        callback(new Error("该值不能小于行业均值"));
      } else {
        callback();
      }
    };
    var firstBuyExcellentMoreValue = (rule, value, callback) => {
      if (Number(value) < Number(this.indicatorsForm.firstBuyReachLessValue)) {
        callback(new Error("该值不能小于达标值"));
      } else {
        callback();
      }
    };

    var purchasedReachLessValue = (rule, value, callback) => {
      if (Number(value) < Number(this.indicatorsForm.purchasedMeanValue)) {
        callback(new Error("该值不能小于行业均值"));
      } else {
        callback();
      }
    };
    var purchasedExcellentMoreValue = (rule, value, callback) => {
      if (Number(value) < Number(this.indicatorsForm.purchasedReachLessValue)) {
        callback(new Error("该值不能小于达标值"));
      } else {
        callback();
      }
    };
    var repurchase90ReachLessValue = (rule, value, callback) => {
      if (Number(value) < Number(this.indicatorsForm.repurchase90MeanValue)) {
        callback(new Error("该值不能小于行业均值"));
      } else {
        callback();
      }
    };
    var repurchase90ExcellentMoreValue = (rule, value, callback) => {
      if (
        Number(value) < Number(this.indicatorsForm.repurchase90ReachLessValue)
      ) {
        callback(new Error("该值不能小于达标值"));
      } else {
        callback();
      }
    };

    var lossReachMoreValue = (rule, value, callback) => {
      if (Number(value) > Number(this.indicatorsForm.lossMeanValue)) {
        callback(new Error("该值不能大于行业均值"));
      } else {
        callback();
      }
    };
    var lossExcellentLessValue = (rule, value, callback) => {
      if (Number(value) > Number(this.indicatorsForm.lossReachMoreValue)) {
        callback(new Error("该值不能大于达标值"));
      } else {
        callback();
      }
    };

    var firstBuyMeanValue = (rule, value, callback) => {
      if (Number(value) > Number(this.indicatorsForm.firstBuyReachLessValue)) {
        callback(new Error("该值不能大于达标值"));
      } else {
        callback();
      }
    };
    var purchasedMeanValue = (rule, value, callback) => {
      if (Number(value) > Number(this.indicatorsForm.purchasedReachLessValue)) {
        callback(new Error("该值不能大于达标值"));
      } else {
        callback();
      }
    };
    var repurchase90MeanValue = (rule, value, callback) => {
      if (Number(value) > Number(this.indicatorsForm.repurchase90ReachLessValue)) {
        callback(new Error("该值不能大于达标值"));
      } else {
        callback();
      }
    };
    var lossMeanValue = (rule, value, callback) => {
      if (Number(value) < Number(this.indicatorsForm.lossReachMoreValue)) {
        callback(new Error("该值不能小于达标值"));
      } else {
        callback();
      }
    };
    return {
      visible: true,
      dataLoading: false,
      indicatorsForm: {},
      formId: "",
      isSaveLoading: false,
      rules: {
        firstBuyReachLessValue: [
          { validator: firstBuyReachLessValue, trigger: "blur" }
        ],
        firstBuyExcellentMoreValue: [
          { validator: firstBuyExcellentMoreValue, trigger: "blur" }
        ],
        purchasedReachLessValue: [
          { validator: purchasedReachLessValue, trigger: "blur" }
        ],
        purchasedExcellentMoreValue: [
          { validator: purchasedExcellentMoreValue, trigger: "blur" }
        ],
        repurchase90ReachLessValue: [
          { validator: repurchase90ReachLessValue, trigger: "blur" }
        ],
        repurchase90ExcellentMoreValue: [
          { validator: repurchase90ExcellentMoreValue, trigger: "blur" }
        ],
        lossReachMoreValue: [
          { validator: lossReachMoreValue, trigger: "blur" }
        ],
        lossExcellentLessValue: [
          { validator: lossExcellentLessValue, trigger: "blur" }
        ],

        firstBuyMeanValue: [
          { validator: firstBuyMeanValue, trigger: "blur" }
        ],
        purchasedMeanValue: [
          { validator: purchasedMeanValue, trigger: "blur" }
        ],
        repurchase90MeanValue: [
          { validator: repurchase90MeanValue, trigger: "blur" }
        ],
        lossMeanValue: [
          { validator: lossMeanValue, trigger: "blur" }
        ],

      }
    };
  },
  computed: {},

  mounted() {
    this.getStrategy();
  },
  watch: {},
  methods: {
    // 获取数据
    getStrategy() {
      this.dataLoading = true;
      indexCustom().then(res => {
        this.dataLoading = false;
        if (res.code === 1) {
          if (res.data) {
            this.indicatorsForm = res.data;
            this.formId = res.data.id;
          }
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //恢复默认数据
    oldBtn() {
      this.dataLoading = true;
      index().then(res => {
        this.dataLoading = false;
        if (res.code === 1) {
          if (res.data) {
            this.indicatorsForm = {
              firstBuyMeanValue: res.data.firstBuyMeanValue,
              firstBuyReachLessValue: res.data.firstBuyReachLessValue,
              firstBuyExcellentMoreValue: res.data.firstBuyExcellentMoreValue,

              purchasedMeanValue: res.data.purchasedMeanValue,
              purchasedReachLessValue: res.data.purchasedReachLessValue,
              purchasedExcellentMoreValue: res.data.purchasedExcellentMoreValue,

              repurchase90MeanValue: res.data.repurchase90MeanValue,
              repurchase90ReachLessValue: res.data.repurchase90ReachLessValue,
              repurchase90ExcellentMoreValue:
                res.data.repurchase90ExcellentMoreValue,

              lossMeanValue: res.data.lossMeanValue,
              lossReachMoreValue: res.data.lossReachMoreValue,
              lossExcellentLessValue: res.data.lossExcellentLessValue
            };
          } else {
            this.indicatorsForm = {
              firstBuyMeanValue: "",
              firstBuyReachLessValue: "",
              firstBuyExcellentMoreValue: "",

              purchasedMeanValue: "",
              purchasedReachLessValue: "",
              purchasedExcellentMoreValue: "",

              repurchase90MeanValue: "",
              repurchase90ReachLessValue: "",
              repurchase90ExcellentMoreValue: "",

              lossMeanValue: "",
              lossReachMoreValue: "",
              lossExcellentLessValue: ""
            };
          }
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //保存数据
    saveCustom() {
      if (this.isSaveLoading) {
        return;
      }
      this.isSaveLoading = true;
      this.indicatorsForm.id = this.formId;
      saveCustom(this.indicatorsForm).then(res => {
        this.isSaveLoading = false;
        if (res.code === 1) {
          this.$message.success("保存成功");
          this.$emit("onSave", true);
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //验证表单
    submitForm(formName) {
      this.indicatorsForm.firstBuyExcellentMoreValue = this.indicatorsForm.firstBuyReachLessValue;
      this.indicatorsForm.purchasedExcellentMoreValue = this.indicatorsForm.purchasedReachLessValue;
      this.indicatorsForm.repurchase90ExcellentMoreValue = this.indicatorsForm.repurchase90ReachLessValue;
      this.indicatorsForm.lossExcellentLessValue = this.indicatorsForm.lossReachMoreValue;

      if (
        this.indicatorsForm.firstBuyMeanValue == null ||
        this.indicatorsForm.firstBuyMeanValue === "" ||
        this.indicatorsForm.firstBuyReachLessValue == null ||
        this.indicatorsForm.firstBuyReachLessValue === "" ||
        this.indicatorsForm.firstBuyExcellentMoreValue == null ||
        this.indicatorsForm.firstBuyExcellentMoreValue === "" ||
        this.indicatorsForm.purchasedMeanValue == null ||
        this.indicatorsForm.purchasedMeanValue === "" ||
        this.indicatorsForm.purchasedReachLessValue == null ||
        this.indicatorsForm.purchasedReachLessValue === "" ||
        this.indicatorsForm.purchasedExcellentMoreValue == null ||
        this.indicatorsForm.purchasedExcellentMoreValue === "" ||
        this.indicatorsForm.repurchase90MeanValue == null ||
        this.indicatorsForm.repurchase90MeanValue === "" ||
        this.indicatorsForm.repurchase90ReachLessValue == null ||
        this.indicatorsForm.repurchase90ReachLessValue === "" ||
        this.indicatorsForm.repurchase90ExcellentMoreValue == null ||
        this.indicatorsForm.repurchase90ExcellentMoreValue === "" ||
        this.indicatorsForm.lossMeanValue == null ||
        this.indicatorsForm.lossMeanValue === "" ||
        this.indicatorsForm.lossReachMoreValue == null ||
        this.indicatorsForm.lossReachMoreValue === "" ||
        this.indicatorsForm.lossExcellentLessValue == null ||
        this.indicatorsForm.lossExcellentLessValue === ""
      ) {
        this.$message.warning("未填写完所有指标值，请全部填写后保存");
        return false;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveCustom();
        } else {
          return false;
        }
      });
    },
    //输入限制
    getNumberData(e) {
      console.log("e", e);
      if (e > 100) {
        e = 100;
      } else if (e < 0) {
        e = 0.01;
      } else {
      }
      this.inputNumber();
      return e;
    },
    //输入同步
    inputNumber() {
      if (this.indicatorsForm.firstBuyReachLessValue > 100) {
        this.indicatorsForm.firstBuyExcellentMoreValue = 100;
      } else {
        this.indicatorsForm.firstBuyExcellentMoreValue = this.indicatorsForm.firstBuyReachLessValue;
      }

      if (this.indicatorsForm.purchasedReachLessValue > 100) {
        this.indicatorsForm.purchasedExcellentMoreValue = 100;
      } else {
        this.indicatorsForm.purchasedExcellentMoreValue = this.indicatorsForm.purchasedReachLessValue;
      }

      if (this.indicatorsForm.repurchase90ReachLessValue > 100) {
        this.indicatorsForm.repurchase90ExcellentMoreValue = 100;
      } else {
        this.indicatorsForm.repurchase90ExcellentMoreValue = this.indicatorsForm.repurchase90ReachLessValue;
      }

      if (this.indicatorsForm.lossReachMoreValue > 100) {
        this.indicatorsForm.lossExcellentLessValue = 100;
      } else {
        this.indicatorsForm.lossExcellentLessValue = this.indicatorsForm.lossReachMoreValue;
      }
    },
    inputNumber0(e, name) {
      console.log("e111", e);
      if (e == 0) {
        this.indicatorsForm[name] = 0.01;
      }
      this.inputNumber();
      this.$refs["indicatorsForm"].validate(valid => {});
    },
    handleClose() {
      this.$refs["indicatorsForm"].resetFields();
      this.$emit("close");
    }
  }
};
</script>
<style lang='scss'>
.formData {
  .el-loading-spinner .path {
    stroke: #6461e7 !important;
  }
  .el-form-item__label {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
/deep/.el-dialog__footer{
  border-top: 1px solid #F0F0F0;
}
/deep/.el-dialog .el-dialog__header .el-dialog__title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  line-height: 23px;
}
.formData {
  .tips {
    display: flex;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 15px;
    padding-left: 5px;
    margin: 15px 0 0 0;
    // border-left: 4px solid #6461e7;
    border-radius: 2px 2px 2px 2px;

    .string {
      width: 4px;
      height: 16px;
      background: #6461e7;
      border-radius: 2px 2px 2px 2px;
      margin-right: 4px;
    }
  }
  .icon {
    margin-left: 8px;
  }
  .oldBtn {
    width: 108px;
    height: 32px;
    background: rgba(100, 97, 231, 0.1);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #6461e7;
    font-size: 14px;
    color: #6461e7;
    text-align: center;
    cursor: pointer;
  }
  /deep/.el-input__inner:focus,
  .el-input__inner:hover {
    border-color: #6461e7;
  }
  /deep/.el-input__inner:focus,
  .el-input__inner:hover {
    border-color: #6461e7;
  }

  .el-form-item__label {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    padding: 0;
  }
  .el-form-item {
    margin: 15px 50px 0 10px;
  }
  .el-input--small {
    width: 100px;
    height: 32px;
  }
  .el-input--small {
    width: 100px;
    height: 32px;
  }
  .el-form-item__error {
    right: 0;
  }
  .long-form.el-form-item {
    display: flex;
    width: 100%;
    align-items: flex-start;
    .el-form-item__content {
      flex: 1;
      // width: auto;
    }
  }
}

.dialog-footer {
  margin-top: 10px;
  .el-button--primary {
    border-color: #6461e7;
    background: #6461e7;
    border-radius: 4px 4px 4px 4px;
  }
  .el-button--default:hover,
  .el-button--default:focus {
    color: #6461e7;
    border: 1px solid #6461e7 !important;
    background: rgba(100, 97, 231, 0.1);
  }
}
</style>
  